import meineTrends from '../../data/meine_trends';

const state = {
    meine_trends: []
};

const mutations = {
    'SET_MEINE_TRENDS'(state, meine_trends) {
        state.meine_trends = meine_trends;
    }
};

const actions = {
    initNeue: ({commit}) => {
        commit('SET_MEINE_TRENDS', meineTrends)
    }
};
const getters = {
    Meine_trends: state => {
        return state.meine_trends;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/Meine_trends.js